export const formatLocalDate = (date) => {
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, "0");
	const day = String(date.getDate()).padStart(2, "0");
	return `${year}-${month}-${day}`;
};

export const formatDisplayDate = (dateString) => {
	if (!dateString) return "";
	const [year, month, day] = dateString.split("-");
	return `${day}/${month}/${year}`;
};

export const getDefaultFechaDesde = () => formatLocalDate(new Date());
export const getDefaultFechaHasta = () => formatLocalDate(new Date());

export const shiftIsoDateByDays = (value, days) => {
	if (!value) return "";

	const [year, month, day] = String(value).split("-").map(Number);
	if (!year || !month || !day) return value;

	const date = new Date(year, month - 1, day);
	date.setDate(date.getDate() + Number(days || 0));

	return formatLocalDate(date);
};
